import * as React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import * as moment from 'moment';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDateFormat } from '../../hooks/useDateFormat';
import ContainerCard from '../Shared/container-card';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import NoRecords from '../Shared/NoRecords';
import { Select } from '../Shared/BsInput';
import { StatsVisitorsListSchema } from '../../validation-schemas';
import Tabs from './tabs';
import GuardsAllowedAccessTable from './guards-allowed-access-table';
import { Link } from 'react-router-dom';

const RenderForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  isSubmitting,
  t,
  isValid,
  setFieldValue,
  buildings,
}) => {
  const { dateTimeFormat, ampm } = useDateFormat();
  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <Grid spacing={3} container>
        <Grid item xs={12} sm={6} md={3}>
          <Select
            className="pt-3"
            label={t('Building')}
            name="building_id"
            value={values.building_id}
            errors={errors}
            onChange={handleChange}
            options={buildings.map((b) => {
              return { value: b.id, label: b.name };
            })}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DateTimePicker
            format={dateTimeFormat}
            ampm={ampm}
            value={values.from}
            disableFuture
            minDate={moment().subtract(90, 'days').format()}
            views={['year', 'month', 'date']}
            onChange={(value) => {
              setFieldValue('from', value);
            }}
            fullWidth
            autoOk
            margin="normal"
            label={t('Date from')}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DateTimePicker
            format={dateTimeFormat}
            ampm={ampm}
            value={values.to}
            disableFuture
            views={['year', 'month', 'date']}
            onChange={(value) => {
              setFieldValue('to', value);
            }}
            fullWidth
            autoOk
            margin="normal"
            label={t('Date to')}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Select
            className="pt-3"
            label={t('Event')}
            name="type"
            value={values.type}
            errors={errors}
            onChange={handleChange}
            options={[
              { value: '__none__', label: t('All') },
              { value: 'ENTRY', label: t('guard.access.ENTRY') },
              { value: 'EXIT', label: t('guard.access.EXIT') },
              { value: 'DENY_ENTRY', label: t('guard.access.DENY_ENTRY') },
            ]}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <Button
            className="mt-4"
            variant="contained"
            color="default"
            type="submit"
            disabled={isSubmitting}
            fullWidth
          >
            {t('Search')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ({ onSubmit, buildings, form, data }) => {
  const { t, i18n } = useTranslation();

  if (!buildings.length) {
    return (
      <div className="alert alert-info text-center">
        {t('You need to be building manager to see reports')}
      </div>
    );
  }

  const lang = i18n.language.substr(0, 2);
  const momentLocale = lang === 'zh' ? 'zh-cn' : lang;
  moment.locale(momentLocale);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={momentLocale} key={momentLocale}>
      <ContainerCard
        xs={12}
        md={12}
        lg={12}
        header={
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div />
            <Typography variant="h6" align="center">
              {t('Access allowed by guards')}
            </Typography>
            <div className="pull-right">
              <Link to="/app/stats">
                <i className="fa fa-share fa-flip-horizontal"></i>
              </Link>
            </div>
          </div>
        }
        content={
          <>
            <Formik
              initialValues={form}
              validationSchema={StatsVisitorsListSchema}
              onSubmit={async (values, { setSubmitting, setErrors }) => {
                try {
                  await onSubmit(values);
                  setSubmitting(false);
                } catch (err) {
                  if (err.response && err.response.data.errors) {
                    setErrors(err.response.data.errors);
                  }

                  setSubmitting(false);
                }
              }}
              render={(p) => <RenderForm {...p} {...{ t, buildings }} />}
            />
            <hr />
            {data && !data.length && <NoRecords />}
            {data && data.length && <GuardsAllowedAccessTable data={data} />}
          </>
        }
        style={{ marginBottom: '15px' }}
      />
    </MuiPickersUtilsProvider>
  );
};
